var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "LayoutFullPage",
    { attrs: { backLink: _vm.URL_SETTINGS_PAGES } },
    [
      _c(
        "div",
        { staticClass: "typographies-display-medium enable-conformity__title" },
        [
          _vm._v(
            "\n        " +
              _vm._s(
                _vm.$t.__(
                  "settings.sellsymodule.invoicing.enable_conformity.title"
                )
              ) +
              "\n    "
          )
        ]
      ),
      _vm._v(" "),
      _c(
        "div",
        {
          staticClass:
            "typographies-paragraph-medium-regular enable-conformity__explanation"
        },
        [
          _vm._v(
            "\n        " +
              _vm._s(
                _vm.$t.__(
                  "settings.sellsymodule.invoicing.enable_conformity.explanation"
                )
              ) +
              "\n    "
          )
        ]
      ),
      _vm._v(" "),
      _c(
        "div",
        { staticClass: "enable-conformity__rules" },
        [
          _c(
            "div",
            {
              staticClass:
                "typographies-heading-h4 enable-conformity__rules--title"
            },
            [
              _vm._v(
                "\n            " +
                  _vm._s(
                    _vm.$t.__(
                      "settings.sellsymodule.invoicing.enable_conformity.rules_title"
                    )
                  ) +
                  "\n        "
              )
            ]
          ),
          _vm._v(" "),
          _c(
            "div",
            { staticClass: "enable-conformity__rules-list" },
            _vm._l(_vm.conformRuleText, function(ruleText, index) {
              return _c(
                "div",
                {
                  key: index,
                  staticClass:
                    "typographies-paragraph-medium-regular enable-conformity__rules-list-item"
                },
                [
                  _c("CompassIcon", {
                    attrs: { icon: "success-circle-fill", type: "success" }
                  }),
                  _vm._v(
                    "\n                " + _vm._s(ruleText) + "\n            "
                  )
                ],
                1
              )
            }),
            0
          ),
          _vm._v(" "),
          _c("CompassCheckbox", {
            attrs: {
              modelValue: _vm.$t.__(
                "settings.sellsymodule.invoicing.enable_conformity.checkbox_rules"
              )
            },
            on: {
              change: function(value) {
                return (_vm.rulesChecked = value)
              }
            }
          })
        ],
        1
      ),
      _vm._v(" "),
      _c("CompassAlert", {
        staticClass: "enable-conformity__alert",
        attrs: {
          type: "warning",
          description: _vm.$t.__(
            "settings.sellsymodule.invoicing.enable_conformity.alert_text"
          ),
          showClose: false
        }
      }),
      _vm._v(" "),
      _c("CompassCheckbox", {
        staticClass: "enable-conformity__acknowledge-changes",
        attrs: {
          modelValue: _vm.$t.__(
            "settings.sellsymodule.invoicing.enable_conformity.checkbox_acknowledge_changes"
          )
        },
        on: {
          change: function(value) {
            return (_vm.acknowledgeChangesChecked = value)
          }
        }
      }),
      _vm._v(" "),
      _c(
        "div",
        { staticClass: "enable-conformity__actions" },
        [
          _c("CompassButton", {
            attrs: {
              type: "secondary",
              label: _vm.$t.__("common.actions.cancel")
            },
            on: { click: _vm.returnToSettingsPages }
          }),
          _vm._v(" "),
          _c("CompassButton", {
            attrs: {
              loading: _vm.confirmationPending,
              disabled: !_vm.acknowledgeChangesChecked || !_vm.rulesChecked,
              label: _vm.$t.__(
                "settings.sellsymodule.invoicing.enable_conformity.confirm_button"
              )
            },
            on: { click: _vm.handleConfirm }
          })
        ],
        1
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }